import { useEffect } from "react";

interface UseScrollInterruptionListenersInput {
  scrollRef: React.RefObject<HTMLDivElement | null>;
  isAutoScrollingRef: React.RefObject<boolean>;
  cancelAutoScroll: () => void;
}

export function useScrollInterruptionListeners({
  scrollRef,
  isAutoScrollingRef,
  cancelAutoScroll,
}: UseScrollInterruptionListenersInput): void {
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onWheel = () => {
      if (isAutoScrollingRef.current) {
        cancelAutoScroll();
      }
    };
    const onTouchStart = () => {
      if (isAutoScrollingRef.current) {
        cancelAutoScroll();
      }
    };

    el.addEventListener("wheel", onWheel, { passive: true });
    el.addEventListener("touchstart", onTouchStart, { passive: true });

    return () => {
      el.removeEventListener("wheel", onWheel);
      el.removeEventListener("touchstart", onTouchStart);
    };
  }, [scrollRef, isAutoScrollingRef, cancelAutoScroll]);
}
